import { transparentize } from "polished";
import * as React from "react";
import { useInView } from "react-intersection-observer";
import { ResponsiveContainer, YAxis, AreaChart, Area } from "recharts";
import { getTrendColor } from "../../../utils/styles/get-trend-color";
import { grid } from "../design-tokens/grid";
import { Device } from "../design-tokens/media-queries";

interface SparklineProps {
  price?: (number | null)[];
  changePercent?: number | null;
}

const Sparkline: React.FC<SparklineProps> = ({ price, changePercent }) => {
  const { inView, ref } = useInView({ triggerOnce: true });

  if (!price) {
    return null;
  }

  const data = price
    .filter((_, i) => i % 4 === 0 || i === price.length - 1)
    .map((d) => ({ value: d }));
  const color = getTrendColor(changePercent);

  return (
    <div
      ref={ref}
      css={{
        width: grid(9),
        height: grid(2.5),
        [Device.DesktopTablet]: { width: grid(11.5), height: grid(3) },
      }}
    >
      {inView && (
        <ResponsiveContainer>
          <AreaChart
            data={data}
            margin={{ top: 0, bottom: 0, left: 0, right: 0 }}
          >
            <defs>
              <linearGradient
                id={`sparkline_gradient_${color}`}
                x1="0"
                y1="0"
                x2="0"
                y2="1"
              >
                <stop offset="0%" stopColor={transparentize(0.5, color)} />
                <stop offset="100%" stopColor={transparentize(1, color)} />
              </linearGradient>
            </defs>
            <YAxis domain={["dataMin", "dataMax"]} hide={true} scale="linear" />
            <Area
              type="monotone"
              dataKey="value"
              fill={`url(#sparkline_gradient_${color})`}
              stroke={color}
              strokeWidth={1.5}
              connectNulls={true}
              animationDuration={500}
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default Sparkline;
